export default {
  listMediumProtocol: [],
  mediumProtocol: {
    descricao: '',
    ativo: true,
  },
}
